import { z } from "zod";
import { AGENT_ROLES, HIRE_TARGET_TYPES } from "../constants.js";
export const createHireProposalSchema = z.object({
    companyId: z.string().uuid(),
    proposedByAgentId: z.string().uuid().nullable().optional(),
    proposedByUserId: z.string().nullable().optional(),
    proposedName: z.string().min(1).max(100),
    proposedRole: z.enum(AGENT_ROLES).optional(),
    proposedTitle: z.string().max(100).optional(),
    proposedReportsTo: z.string().uuid().nullable().optional(),
    hireTargetType: z.enum(HIRE_TARGET_TYPES),
    hireTargetConfig: z.record(z.unknown()).optional(),
    justification: z.string().max(5000).optional(),
});
export const updateHireProposalSchema = z.object({
    proposedName: z.string().min(1).max(100).optional(),
    proposedRole: z.enum(AGENT_ROLES).optional(),
    proposedTitle: z.string().max(100).nullable().optional(),
    proposedReportsTo: z.string().uuid().nullable().optional(),
    hireTargetType: z.enum(HIRE_TARGET_TYPES).optional(),
    hireTargetConfig: z.record(z.unknown()).optional(),
    justification: z.string().max(5000).nullable().optional(),
});
//# sourceMappingURL=hiring.js.map